<div class="container-fluid">
  <mat-card *ngIf="employees">
    <a id="newVehicleCreate" mat-raised-button [routerLink]="['create']" color="primary" matTooltip="Create New Vehicle"
      [matTooltipPosition]="'right'">
      <mat-icon class="add-icon">add</mat-icon>
      Vehicle
    </a>
    <mat-card-content>
      <mat-table #table [dataSource]="dataSource">
        <ng-container matColumnDef="assignedDriver">
          <mat-header-cell *matHeaderCellDef> Assigned Driver </mat-header-cell>
          <mat-cell id="assignedDriverStatus" *matCellDef="let element" [attr.assignedDriver]="element.vehicleId">
            <span *ngIf="element.assignedEmployeeId"> {{filterEmployee(element.assignedEmployeeId)?.firstName}}
              {{filterEmployee(element.assignedEmployeeId)?.lastName}}</span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="vehicleNumber">
          <mat-header-cell *matHeaderCellDef (click)="sortByvehicleNumber()" class="clickable">
            Vehicle Number<mat-icon class="twelve">sort</mat-icon>
          </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.vehicleNumber}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="vehicleVin">
          <mat-header-cell *matHeaderCellDef>VIN</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.vin}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="vehicleIsActive">
          <mat-header-cell *matHeaderCellDef> Vehicle Status </mat-header-cell>
          <mat-cell *matCellDef="let element" [attr.vehicleStatus]="element.vehicleId">
            <span *ngIf="element.vehicleStatus === 0">Available</span>
            <span *ngIf="element.vehicleStatus === 1">Assigned</span>
            <span *ngIf="element.vehicleStatus === 2">Maintenance</span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="licensePlate">
          <mat-header-cell *matHeaderCellDef> License Plate </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.vehicleRegistration?.licensePlateState}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="vehicleId">
          <mat-header-cell *matHeaderCellDef> Actions </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <button mat-icon-button id="kebabMenu" [matMenuTriggerFor]="menu"
              aria-label="Example icon-button with a menu" [attr.data-id]="element.vehicleId">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <!-- <button mat-menu-item color="default" type="button" [routerLink]="['addexpense',element.vehicleId]">
                    <mat-icon>add</mat-icon>
                    <span>Add Expense</span>
                  </button> -->
              <button mat-menu-item color="accent" type="button" [routerLink]="['detail',element.vehicleId]">
                <mat-icon>edit</mat-icon>
                <span>Details/Edit</span>
              </button>
              <button mat-menu-item color="primary" type="button" [routerLink]="['addMileage',element.vehicleId]">
                <mat-icon>add</mat-icon>
                <span>Add Mileage</span>
              </button>
              <button mat-menu-item color="warn" type="button" (click)="deleteVehicle(element.vehicleId)">
                <mat-icon>delete_outline</mat-icon>
                <span>Retire</span>
              </button>
              <button mat-menu-item color="warn" type="button" (click)="unassignVehicle(element.vehicleId)"
                *ngIf="element.vehicleStatus == 1">
                <mat-icon>cancel</mat-icon>
                <span>Unassign Driver</span>
              </button>
              <button mat-menu-item color="warn" type="button" (click)="reassignVehicle(element.vehicleId)"
                *ngIf="element.vehicleStatus !== 1">
                <mat-icon>assignment_ind</mat-icon>
                <span>Assign Driver</span>
              </button>
            </mat-menu>
          </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
      </mat-table>
      <div *ngIf="!(dataSource && dataSource.data.length > 0)" class="no-records">
        No records found
      </div>
      <mat-paginator (page)="pageChangedEventVehicles($event)" *ngIf="vehiclesData" [length]="vehiclesData?.length"
        [pageSize]="50" [pageIndex]="0" [pageSizeOptions]="[5, 25, 50, 100]"> </mat-paginator>
    </mat-card-content>
  </mat-card>
</div>